function init() {
  const el = document.getElementById("refiner-config")
  if (!el) return

  let config
  try {
    config = JSON.parse(el.textContent)
  } catch {
    return
  }

  import("refiner-js").then((mod) => {
    const refiner = mod.default ?? mod
    refiner("setProject", config.environment_id).catch(() => {})
    refiner("identifyUser", config.traits).catch(() => {})
    if (config.survey_id) refiner("showForm", config.survey_id).catch(() => {})
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init)
} else {
  init()
}
